import { AxiosError } from 'axios';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../../../../../components/Modal';
import {
  backendErrorNotification,
  frontendNotification,
} from '../../../../../components/Notification';
import HttpStatus from '../../../../../enums/httpStatus';
import { orderStatusApi } from '../../../../../services/requests';

type Props = {
  closeModal: () => void;
  reqGetAllOrderStatuses: () => void;
};

const CreateOrderStatus = ({ closeModal, reqGetAllOrderStatuses }: Props) => {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);
  const [key, setKey] = useState('');
  const [description, setDescription] = useState('');
  const [alt1, setAlt1] = useState('');
  const [alt2, setAlt2] = useState('');

  const reqCreateOrderStatus = async () => {
    setIsLoading(true);

    const source = orderStatusApi.axios.CancelToken.source();

    try {
      const res = await orderStatusApi.store({
        key,
        description,
        alt_1: alt1 || null,
        alt_2: alt2 || null,
      });

      if (res.status === HttpStatus.OK || res.status === HttpStatus.CREATED) {
        setIsLoading(false);
        frontendNotification({
          message: t('successfullyCreated'),
          type: 'success',
        });

        closeModal();
        reqGetAllOrderStatuses();
      } else {
        throw res;
      }

      setIsLoading(false);
    } catch (err) {
      if (!orderStatusApi.axios.isCancel(err)) {
        backendErrorNotification(err as AxiosError<any, any>);
      }
      setIsLoading(false);
    }

    return () => {
      source.cancel('Component got unmounted');
    };
  };

  return (
    <Modal
      title={t('createOrderStatus')}
      showModal
      closeModal={closeModal}
      action={() => reqCreateOrderStatus()}
      isLoading={isLoading}
    >
      <div className="form">
        <div className="form-row">
          <div className="form-row-item">
            <label htmlFor="orderStatusKey">{t('key') as string}</label>
            <input
              id="orderStatusKey"
              type="text"
              value={key}
              onChange={(e) => setKey(e.target.value)}
              disabled={isLoading}
            />
          </div>
          <div className="form-row-item">
            <label htmlFor="orderStatusDescription">{t('description') as string}</label>
            <input
              id="orderStatusDescription"
              type="text"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              disabled={isLoading}
            />
          </div>
        </div>
        <div className="form-row">
          <div className="form-row-item">
            <label htmlFor="orderStatusAlt1">{t('alt1') as string}</label>
            <input
              id="orderStatusAlt1"
              type="text"
              value={alt1}
              onChange={(e) => setAlt1(e.target.value)}
              disabled={isLoading}
            />
          </div>
          <div className="form-row-item">
            <label htmlFor="orderStatusAlt2">{t('alt2') as string}</label>
            <input
              id="orderStatusAlt2"
              type="text"
              value={alt2}
              onChange={(e) => setAlt2(e.target.value)}
              disabled={isLoading}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default CreateOrderStatus;
